module.exports = __webpack_public_path__ + "img/klaus-a1-1.fe73a625.png";